// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminHeadMonth_wrapper__5iHh8"};